import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Flex from 'legacyfrontend/components/Flex';
import PackageCardButton from '../../../PackageCardButton';
import { usePackageCard } from 'legacyfrontend/contexts/PackageCardContext';
import { formatWithMomentFormat, utcToLocal } from 'legacyfrontend/utils/dateUtils';
import { DATE_KEYS } from 'legacyfrontend/constants';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const InfoHeader = ({ tabs }) => {
  const { t } = useTranslation('layout');
  const departureDateLabel = t('packages.departure_date');
  const { departureDates, departureDatesIsLoading, filters, handleFilters } = usePackageCard();

  const handleDepartureOnChange = ({ target: { value, name } }) => {
    handleFilters(name, value);
  };

  useEffect(() => {
    if (!!departureDates?.length && !filters.departureDate?.value) {
      handleFilters('departureDate', departureDates[0]);
    }
  }, [departureDates]);

  return (
    <Flex className='package-card__dynamic-content__header'>
      <Flex className='package-card__dynamic-content__header__buttons'>
        {tabs.map((tabKey) => (
          <PackageCardButton key={tabKey} tabKey={tabKey} />
        ))}
      </Flex>
      <FormControl>
        <InputLabel id='departureDateLabel'>{departureDateLabel}</InputLabel>
        <Select
          label={departureDateLabel}
          labelId='departureDateLabel'
          name='departureDate'
          onChange={handleDepartureOnChange}
          style={{
            marginLeft: 'auto',
            marginBottom: '0.5rem',
            flex: 1,
            justifyContent: 'flex-end',
            minWidth: '200px',
          }}
          value={filters.departureDate?.value || ''}
          variant='outlined'
        >
          {departureDatesIsLoading ? (
            <MenuItem value=''>{t('packages.fetching_dates')}</MenuItem>
          ) : !departureDates?.length ? (
            <MenuItem value=''>{t('common.unavailable')}</MenuItem>
          ) : (
            departureDates.map((date) => (
              <MenuItem key={date} value={date}>
                {formatWithMomentFormat(utcToLocal(date), DATE_KEYS.FORMAT.NUMBER_MONTHNAME_YEAR)}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Flex>
  );
};

export default InfoHeader;
